import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";

@Component({
	selector: "app-auth-callback",
	template: "<p>Processing authentication...</p>",
})
export class AuthCallbackComponent implements OnInit {
	claims: any;

	constructor(private oauthService: OAuthService, private router: Router) {}

	ngOnInit(): void {
		// Process the login callback (if not already handled globally)
		this.oauthService.tryLogin().then(() => {
			if (this.oauthService.hasValidAccessToken()) {
				// attempt to redirect to intended url or homepage after successful authentication
				let intendedUrl = localStorage.getItem("intendedUrl") || "/";
				localStorage.removeItem("intendedUrl");
				//prevent redirect loop to /logout
				if (intendedUrl === "/logout") {
					intendedUrl = "/";
				}
				this.router.navigateByUrl(intendedUrl);
			}
		});
	}
}
